const stepable = {
  props: {
    steps: {
      type: Array,
      required: true
    },
    currentStep: {
      type: String,
      required: true
    },
    maxStep: {
      type: String,
      required: true
    }
  },
  methods: {
    stepIndex(step) {
      return this.steps.indexOf(step)
    },
    currentStepIndex() {
      return this.steps.indexOf(this.currentStep)
    },
    maxStepIndex() {
      return this.steps.indexOf(this.maxStep)
    }
  }
}

export default stepable
